
import { Product } from "@/lib/types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface ProductUsageItemProps {
  product: Product;
  isSelected: boolean;
  quantity: number;
  onToggle: (id: string, checked: boolean) => void;
  onQuantityChange: (id: string, quantity: number) => void;
}

const ProductUsageItem = ({ 
  product, 
  isSelected, 
  quantity, 
  onToggle, 
  onQuantityChange 
}: ProductUsageItemProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Checkbox
            id={`product-${product.id}`}
            checked={isSelected}
            onCheckedChange={(checked) => 
              onToggle(product.id, !!checked)
            }
          />
          <Label
            htmlFor={`product-${product.id}`}
            className="text-sm cursor-pointer"
          >
            {product.name}
          </Label>
        </div>
        {isSelected && (
          <Input
            type="number"
            min="1"
            className="w-20 h-8 text-sm"
            value={quantity}
            onChange={(e) => 
              onQuantityChange(product.id, Number(e.target.value))
            }
            onClick={(e) => (e.target as HTMLInputElement).select()}
            inputMode="numeric"
            pattern="[0-9]*"
          />
        )}
      </div>
      {isSelected && (
        <p className="text-xs text-gray-500 dark:text-gray-400 pl-6">
          Current stock: {product.currentStock} units
        </p>
      )}
    </div>
  );
};

export default ProductUsageItem;
